export const newAppVersionReceived = (shouldReloadApp) => ({
  type: 'NEW_APP_VERSION_RECEIVED',
  shouldReloadApp,
});
